import { HelpCenterCardComponent } from './help-center-card/help-center-card.component';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '@fundamental-ngx/core/button';
import {
  DynamicPageComponent,
  DynamicPageContentComponent,
  DynamicPageHeaderComponent,
} from '@fundamental-ngx/core/dynamic-page';
import { InputGroupComponent } from '@fundamental-ngx/core/input-group';
import { TitleComponent } from '@fundamental-ngx/core/title';
import { LuigiContextService } from '@luigi-project/client-support-angular';
import { LuigiCoreService } from '@openmfp/portal-ui-lib';
import { map } from 'rxjs/operators';

export interface HelpContext {
  displayName?: string;
  issueTracker?: {
    url: string;
  };
  feedbackTracker?: {
    url: string;
  };
  stackSearch?: {
    tags: string[];
  };
  documentation?: {
    url: string;
  };
}
const STACK_SEARCH_URL = 'https://sap.stackenterprise.co/search';

@Component({
  selector: 'app-help-center',
  imports: [
    DynamicPageComponent,
    DynamicPageHeaderComponent,
    DynamicPageContentComponent,
    TitleComponent,
    InputGroupComponent,
    ButtonComponent,
    FormsModule,
    HelpCenterCardComponent,
  ],
  templateUrl: './help-center.component.html',
  styleUrl: './help-center.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpCenterComponent implements AfterContentInit {
  private luigiCoreService = inject(LuigiCoreService);
  private luigiContextService = inject(LuigiContextService);

  helpContext = toSignal<HelpContext>(
    this.luigiContextService
      .contextObservable()
      .pipe(map((ctx) => ctx.context?.helpContext)),
    { initialValue: null },
  );
  searchInput = '';

  ngAfterContentInit() {
    this.luigiCoreService.ux().hideAppLoadingIndicator();
  }

  showBugTrackerCard(): boolean {
    return !!this.helpContext()?.issueTracker;
  }
  showFeedbackTrackerCard(): boolean {
    return !!this.helpContext()?.feedbackTracker;
  }
  showDocumentationCard(): boolean {
    return !!this.helpContext()?.documentation;
  }

  goToFeedback() {
    this.openInNewTab(this.helpContext()?.feedbackTracker?.url);
  }

  goToBugReporting() {
    this.openInNewTab(this.helpContext()?.issueTracker?.url);
  }

  goToDocumentation() {
    this.openInNewTab(this.helpContext()?.documentation?.url);
  }

  goToStack() {
    let query = '';
    const tags = this.helpContext()?.stackSearch?.tags;
    (tags || []).forEach((tag: string) => {
      query += `[${tag}] `;
    });

    if (this.searchInput) {
      query += this.searchInput;
    }
    const encodedQuery = `?q=${encodeURIComponent(query)}`;
    this.openInNewTab(`${STACK_SEARCH_URL}${encodedQuery}`);
  }

  private openInNewTab(url?: string) {
    if (url) {
      window.open(url, '_blank', 'noreferrer');
    }
  }
}
